import { createFileRoute } from "@tanstack/react-router";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { ChatContainer } from "@/components/features/Chat/ChatContainer";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import styles from "./chat.module.scss";

export const Route = createFileRoute("/_authenticated/chat/")({
  component: Chat,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function Chat() {
  useBreadcrumb([
    {
      title: "Chat",
      href: "/chat",
      icon: getRouteIcon(MODULE_KEYS_MAP.chat),
    },
  ]);

  return <ChatContainer className={styles.chatRoot} />;
}
